<main>
  <section
    style="
      background-image: url('assets/images/agent-registration-hero.jpg');
      background-size: cover;
      background-position: center;
    "
  >
    <div class="container px-4 py-5">
      <div class="row align-items-start g-lg-5 py-5">
        <div class="col-lg-10 text-lg-start text-light">
          <h1 class="display-4 lh-1 mb-3 py-4">Agent Registration</h1>
        </div>
      </div>
    </div>
  </section>

  <div class="px-4 my-5 text-center">
    <p class="display-5 mb-4">Create your new account</p>
    <div class="col-lg-9 mx-auto">
      <p class="fs-5 mb-4">
        If you're already an authorized DAC agent, but have yet to register your
        online account, please fill in your information below.
      </p>
      <div class="d-grid gap-2 d-sm-flex justify-content-sm-center">
        <a
          class="btn btn-outline-primary px-4 gap-3"
          routerLink="."
          fragment="becomeAgent"
        >
          Not an Authorized Agent?
        </a>
      </div>
    </div>
  </div>

  <div class="container px-4 my-5 py-5">
    <div class="row g-5">
      <div class="col-md-6">
        <h4 class="text-primary mb-4">The DFS difference</h4>
        <p>
          DFS is, always has been, and always will be a relationship-driven
          company. We're a true partner for our agents. Together we provide our
          customers the simplicity, innovation and reliability they expect.
        </p>
      </div>
      <div class="col-md-6">
        <div class="card p-4 fs-6">
          <form [formGroup]="registerForm" (ngSubmit)="onRegister()">
            <p #errorAlert *ngIf="errorMessage" class="text-danger">{{ errorMessage }}</p>
            <div class="col-12 mb-4">
              <label class="form-label">
                Username
                <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                formControlName="userName"
                class="form-control fs-6"
                [ngClass]="{
                  'is-invalid':
                    registerForm.controls['userName'].invalid &&
                    registerForm.controls['userName'].touched,
                }"
                required
              />
              <div
                *ngIf="
                  registerForm.controls['userName'].invalid &&
                  registerForm.controls['userName'].touched
                "
                class="invalid-feedback"
              >
                Username is required.
              </div>
            </div>
            <div class="col-12 mb-4">
              <label class="form-label">
                Agency Number
                <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                formControlName="agencyNumber"
                class="form-control fs-6"
                [ngClass]="{
                  'is-invalid':
                    registerForm.controls['agencyNumber'].invalid &&
                    registerForm.controls['agencyNumber'].touched,
                }"
                (blur)="onAgencyNumberBlur()"
                required
              />
              <div
                *ngIf="
                  registerForm.controls['agencyNumber'].invalid &&
                  registerForm.controls['agencyNumber'].touched
                "
                class="invalid-feedback"
              >
                Agency number is required.
              </div>
            </div>
            <div class="col-12 mb-4">
              <label class="form-label">
                Agency/Agent Name
                <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                formControlName="agencyName"
                class="form-control fs-6"
                [ngClass]="{
                  'is-invalid':
                    registerForm.controls['agencyName'].invalid &&
                    registerForm.controls['agencyName'].touched,
                }"
                required
              />
              <div
                *ngIf="
                  registerForm.controls['agencyName'].invalid &&
                  registerForm.controls['agencyName'].touched
                "
                class="invalid-feedback"
              >
                Agency/Agent name is required.
              </div>
            </div>
            <div class="col-12 mb-4">
              <label class="form-label">
                Agency Contact Name
                <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                formControlName="contactName"
                class="form-control fs-6"
                [ngClass]="{
                  'is-invalid':
                    registerForm.controls['contactName'].invalid &&
                    registerForm.controls['contactName'].touched,
                }"
                required
              />
              <div
                *ngIf="
                  registerForm.controls['contactName'].invalid &&
                  registerForm.controls['contactName'].touched
                "
                class="invalid-feedback"
              >
                Contact name is required.
              </div>
            </div>
            <div class="col-12 mb-4">
              <label class="form-label">
                Agent Email Address
                <span class="text-danger">*</span>
              </label>
              <input
                type="email"
                formControlName="email"
                class="form-control fs-6"
                [ngClass]="{
                  'is-invalid':
                    registerForm.controls['email'].invalid &&
                    registerForm.controls['email'].touched,
                }"
                required
              />
              <div
                *ngIf="
                  registerForm.controls['email'].invalid &&
                  registerForm.controls['email'].touched
                "
                class="invalid-feedback"
              >
                <span
                  *ngIf="registerForm.controls['email'].errors?.['required']"
                >
                  Email address is required.
                </span>
                <span *ngIf="registerForm.controls['email'].errors?.['email']">
                  Please enter a valid email address.
                </span>
              </div>
            </div>
            <div class="col-12 mb-4">
              <label class="form-label">
                Agency Address Line 1
                <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                formControlName="address1"
                class="form-control fs-6"
                [ngClass]="{
                  'is-invalid':
                    registerForm.controls['address1'].invalid &&
                    registerForm.controls['address1'].touched,
                }"
                required
              />
              <div
                *ngIf="
                  registerForm.controls['address1'].invalid &&
                  registerForm.controls['address1'].touched
                "
                class="invalid-feedback"
              >
                Address is required.
              </div>
            </div>
            <div class="col-12 mb-4">
              <label class="form-label">Agency Address Line 2</label>
              <input
                type="text"
                formControlName="address2"
                class="form-control fs-6"
              />
            </div>
            <div class="col-12 mb-4">
              <label class="form-label">
                City
                <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                formControlName="city"
                class="form-control fs-6"
                [ngClass]="{
                  'is-invalid':
                    registerForm.controls['city'].invalid &&
                    registerForm.controls['city'].touched,
                }"
                required
              />
              <div
                *ngIf="
                  registerForm.controls['city'].invalid &&
                  registerForm.controls['city'].touched
                "
                class="invalid-feedback"
              >
                City is required.
              </div>
            </div>
            <div class="col-12 mb-4">
              <label class="form-label">
                State
                <span class="text-danger">*</span>
              </label>
              <select
                formControlName="state"
                class="form-select fs-6"
                [ngClass]="{
                  'is-invalid':
                    registerForm.controls['state'].invalid &&
                    registerForm.controls['state'].touched,
                }"
                required
              >
                <option selected disabled value="">Select your state</option>
                <option *ngFor="let s of states" [value]="s.abbreviation">
                  {{ s.name }}
                </option>
              </select>
              <div
                *ngIf="
                  registerForm.controls['state'].invalid &&
                  registerForm.controls['state'].touched
                "
                class="invalid-feedback"
              >
                State is required.
              </div>
            </div>
            <div class="col-12 mb-4">
              <label class="form-label">
                Zip Code
                <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                formControlName="zipCode"
                class="form-control fs-6"
                [ngClass]="{
                  'is-invalid':
                    registerForm.controls['zipCode'].invalid &&
                    registerForm.controls['zipCode'].touched,
                }"
                required
              />
              <div
                *ngIf="
                  registerForm.controls['zipCode'].invalid &&
                  registerForm.controls['zipCode'].touched
                "
                class="invalid-feedback"
              >
                Zip code is required.
              </div>
            </div>
            <div class="col-12 mb-4">
              <label class="form-label">
                Choose Password
                <span class="text-danger">*</span>
              </label>
              <input
                type="password"
                formControlName="password"
                class="form-control fs-6"
                [ngClass]="{
                  'is-invalid':
                    registerForm.controls['password'].invalid &&
                    registerForm.controls['password'].touched,
                }"
                required
              />
              <div
                *ngIf="
                  registerForm.controls['password'].invalid &&
                  registerForm.controls['password'].touched
                "
                class="invalid-feedback"
              >
                <span
                  *ngIf="registerForm.controls['password'].errors?.['required']"
                >
                  Password is required.
                </span>
                <span
                  *ngIf="registerForm.controls['password'].errors?.['pattern']"
                >
                  Passwords must contain between 12 and 20 characters, both
                  lower and uppercase letters, and at least one number or
                  special character.
                </span>
              </div>
            </div>
            <div class="col-12 mb-4">
              <label class="form-label">
                Confirm Password
                <span class="text-danger">*</span>
              </label>
              <input
                type="password"
                formControlName="confirmPassword"
                class="form-control fs-6"
                [ngClass]="{
                  'is-invalid':
                    registerForm.controls['confirmPassword'].invalid &&
                    registerForm.controls['confirmPassword'].touched,
                }"
                required
              />
              <div
                *ngIf="
                  registerForm.controls['confirmPassword'].invalid &&
                  registerForm.controls['confirmPassword'].touched
                "
                class="invalid-feedback"
              >
                Please confirm your password.
              </div>
              <div *ngIf="passwordMismatch" class="text-danger">
                Passwords do not match.
              </div>
            </div>
            <p-messages
              *ngIf="
                registerSubmitted && (registerForm.invalid || passwordMismatch)
              "
              severity="error"
              [value]="[
                {
                  severity: 'error',
                  detail:
                    'Please correct the validation errors above before submitting.',
                },
              ]"
              [closable]="false"
              class="col-12 mb-4"
            ></p-messages>
            <div class="col-12 mb-4">
              <re-captcha
                (resolved)="getCaptchaValue($event)"
                siteKey="{{ captchaKey }}"
              ></re-captcha>
              <p class="text-danger" *ngIf="registerSubmitted && !captchaIsValid">
                Please validate you are not a robot before submitting.
              </p>
            </div>
            <div class="col-12 mb-4">
              <button type="submit" class="btn btn-primary mt-4">
                Register
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <div id="becomeAgent" class="container px-4 my-5 py-5">
    <div class="row g-5">
      <div class="col-md-6">
        <h4 class="text-primary mb-4">Become an authorized agent.</h4>
        <p>
          Join an industry leader and a team committed to providing exceptional
          service and a personal touch.
        </p>
        <p>
          <strong>Just provide us a few details and we'll be in touch.</strong>
        </p>
      </div>
      <div class="col-md-6">
        <div class="card p-4 fs-6 bg-secondary border-0">
          <form [formGroup]="newAgentForm" (ngSubmit)="onNewAgentSubmit()">
            <div class="col-12 mb-4">
              <label class="form-label">
                Name
                <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                formControlName="name"
                class="form-control fs-6"
                [ngClass]="{
                  'is-invalid':
                    newAgentForm.controls['name'].invalid &&
                    newAgentForm.controls['name'].touched,
                }"
                required
              />
              <div
                *ngIf="
                  newAgentForm.controls['name'].invalid &&
                  newAgentForm.controls['name'].touched
                "
                class="invalid-feedback"
              >
                Name is required.
              </div>
            </div>
            <div class="col-12 mb-4">
              <label class="form-label">
                Email address
                <span class="text-danger">*</span>
              </label>
              <input
                type="email"
                formControlName="email"
                class="form-control fs-6"
                [ngClass]="{
                  'is-invalid':
                    newAgentForm.controls['email'].invalid &&
                    newAgentForm.controls['email'].touched,
                }"
                required
              />
              <div
                *ngIf="
                  newAgentForm.controls['email'].invalid &&
                  newAgentForm.controls['email'].touched
                "
                class="invalid-feedback"
              >
                <span
                  *ngIf="newAgentForm.controls['email'].errors?.['required']"
                >
                  Email address is required.
                </span>
                <span *ngIf="newAgentForm.controls['email'].errors?.['email']">
                  Please enter a valid email address.
                </span>
              </div>
            </div>
            <div class="col-12 mb-4">
              <label class="form-label">
                Phone Number
                <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                formControlName="phone"
                class="form-control fs-6"
                [ngClass]="{
                  'is-invalid':
                    newAgentForm.controls['phone'].invalid &&
                    newAgentForm.controls['phone'].touched,
                }"
                required
              />
              <div
                *ngIf="
                  newAgentForm.controls['phone'].invalid &&
                  newAgentForm.controls['phone'].touched
                "
                class="invalid-feedback"
              >
                Phone number is required.
              </div>
            </div>
            <div class="col-12 mb-4">
              <button type="submit" class="btn btn-primary mt-2">Submit</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</main>
